var drinks = [
    {
        "id": "49",
        "name": "Iced Guava Pepsi",
        "category": "drinks",
        "img": "https://i.imgur.com/BMJqNo6.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 2.99
    },
    {
        "id": "50",
        "name": "Cinnamon Coca cola",
        "category": "drinks",
        "img": "https://i.imgur.com/Yj4w7ij.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 2.69
    },
    {
        "id": "51",
        "name": "Dolce Latte Red Bull",
        "category": "drinks",
        "img": "https://i.imgur.com/tIknImD.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 1.99
    },
    {
        "id": "52",
        "name": "Starbucks Strawberry Frappuccino",
        "category": "drinks",
        "img": "https://i.imgur.com/91aNPOB.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 2.49
    },
    {
        "id": "53",
        "name": "Cream Cold Americano",
        "category": "drinks",
        "img": "https://i.imgur.com/ve3sMZn.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 2.69
    },
    {
        "id": "54",
        "name": "Starbucks Cold Brew",
        "category": "drinks",
        "img": "https://i.imgur.com/JftzAqb.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 2.79
    },


]
export default drinks;